import { render, staticRenderFns } from "./TwPermitHistory.vue?vue&type=template&id=2a412d9a&scoped=true&"
import script from "./TwPermitHistory.vue?vue&type=script&lang=js&"
export * from "./TwPermitHistory.vue?vue&type=script&lang=js&"
import style0 from "./TwPermitHistory.vue?vue&type=style&index=0&id=2a412d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a412d9a",
  null
  
)

export default component.exports